export const adjustPathnameLocale = (
  pathname: string,
  defaultLocale = 'en'
) => {
  if (pathname.startsWith(`/${defaultLocale}`)) {
    return pathname.replace(`/${defaultLocale}`, '');
  }

  return pathname;
};

export default adjustPathnameLocale;
